import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.stringify.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    attrs: {
      "title": _vm.title,
      "bordered": false,
      "size": "small"
    }
  }, [_c('template', {
    slot: "extra"
  }, [_vm.mode !== 'view' ? _c('div', [_c('a-button', {
    on: {
      "click": _vm.backPage
    }
  }, [_vm._v("返回")]), _vm.mode === 'evaluation' && _vm.$route.query.repairsStatus == 7 ? _c('a-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.evaluationShow
    }
  }, [_vm._v(" 提交评价 ")]) : _vm._e(), _vm.mode === 'accept' && _vm.$route.query.repairsStatus == 1 || _vm.$route.query.repairsStatus == 2 ? _c('a-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.acceptClick
    }
  }, [_vm._v(" 受理 ")]) : _vm._e(), _vm.$route.query.repairsStatus == 3 || _vm.$route.query.repairsStatus == 1 || _vm.$route.query.repairsStatus == 2 ? _c('a-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.orderClick
    }
  }, [_vm._v(" 接单 ")]) : _vm._e(), _vm.$route.query.repairsStatus == 5 || _vm.$route.query.repairsStatus == 3 || _vm.$route.query.repairsStatus == 1 || _vm.$route.query.repairsStatus == 2 ? _c('a-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.feedbackClick
    }
  }, [_vm._v(" 反馈 ")]) : _vm._e(), _vm.$route.query.repairsStatus == 3 ? _c('a-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.acceptFeedbackClick
    }
  }, [_vm._v(" 转派 ")]) : _vm._e(), _vm.$route.query.repairsStatus == 5 ? _c('a-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.acceptFeedbackClick
    }
  }, [_vm._v(" 转派 ")]) : _vm._e()], 1) : _c('div', [_c('a-button', {
    on: {
      "click": _vm.backPage
    }
  }, [_vm._v("返回")])], 1)])], 2), _c('a-row', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "gutter": 2
    }
  }, [_vm.$route.query.repairsStatus != 0 ? _c('div', {
    staticClass: "lc-wapper"
  }, [_c('div', {
    staticClass: "sliderbar-off",
    on: {
      "click": _vm.clickChange
    }
  }, [_c('a-icon', {
    attrs: {
      "type": _vm.sliderbar ? 'double-right' : 'double-left'
    }
  }), _vm._v(" 流转记录 ")], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.sliderbarShow,
      expression: "sliderbarShow"
    }],
    class: !_vm.sliderbar ? 'right-close' : 'right-open'
  }, [_c('div', {
    staticStyle: {
      "background": "#fff",
      "width": "100%",
      "height": "100%",
      "border-left": "1px solid #e6e6e6",
      "border-top": "1px solid #e6e6e6"
    }
  }, [_c('a-card', {
    attrs: {
      "size": "small",
      "bodyStyle": _vm.cardBodyStyle,
      "title": "报修流程"
    }
  }, [_c('div', [_c('a-timeline', _vm._l(_vm.recordList, function (item, index) {
    return _c('a-timeline-item', {
      key: index,
      attrs: {
        "color": item.status === 1 ? 'rgb(79, 191, 73)' : item.status === 4 || item.status === 5 ? 'rgb(220, 33, 39)' : item.status === 7 || item.status === 8 || item.status === 9 ? 'rgb(79, 191, 73)' : 'rgb(24, 144, 255)'
      }
    }, [_c('div', {
      staticClass: "timeline-title",
      attrs: {
        "title": item.status
      }
    }, [_vm._v(" " + _vm._s(item.status == 1 ? '报修' : item.status == 2 ? '受理' : item.status == 3 ? '转派' : item.status == 4 ? '驳回/不接单' : item.status == 5 ? '转派' : item.status == 6 ? '接单' : item.status == 7 ? '完工' : item.status == 8 ? '评价' : item.status == 9 ? '校外人员维修' : '维修完成') + " ")]), _c('a-card', {
      staticClass: "processMsg",
      attrs: {
        "body-style": {
          padding: '10px'
        }
      }
    }, [_c('a-row', [_c('div', [_c('span', [_vm._v(" " + _vm._s(item.status == 1 ? '报修人：' : item.status == 2 ? '受理人：' : item.status == 3 ? '转派人：' : item.status == 4 ? '驳回人：' : item.status == 5 ? '转派人：' : item.status == 6 ? '接单人：' : item.status == 7 ? '维修人：' : item.status == 8 ? '评价人：' : item.status == 9 ? '校外人员维修:' : '维修完成：') + _vm._s(item.userName) + " ")])]), _c('div', [_vm._v(" " + _vm._s(item.status == 1 ? '填报时间：' : item.status == 2 ? '受理时间：' : item.status == 3 ? '转派时间：' : item.status == 4 ? '驳回时间：' : item.status == 5 ? '转派时间：' : item.status == 6 ? '接单时间：' : item.status == 7 ? '维修时间：' : item.status == 8 ? '评价时间：' : item.status == 9 ? '校外人员维修' : '校外人员维修完成时间：') + _vm._s(item.eventTime) + " ")]), JSON.stringify(item.type) != 'null' ? _c('div', [_vm._v(" 维修类别：" + _vm._s(item.type == 0 ? '校内人员维修' : '校外人员维修') + " ")]) : _vm._e(), _c('div', {
      staticClass: "text-ellipsis",
      attrs: {
        "title": item.content
      }
    }, [_vm._v(" 备注信息：" + _vm._s(JSON.stringify(item.content) == 'null' ? '无' : item.content) + " ")]), _c('div', [_vm._v(" 附件：" + _vm._s(JSON.stringify(item.faultImgList) == 'null' ? '无' : '') + " ")]), JSON.stringify(item.faultImgList) != 'null' ? _c('div', {
      staticStyle: {
        "display": "flex",
        "margin-top": "5px"
      }
    }, _vm._l(item.faultImgList, function (i, index) {
      return _c('div', {
        key: index,
        staticStyle: {
          "margin-right": "10px"
        }
      }, [_c('a', {
        attrs: {
          "href": "".concat(_vm.config.baseUrl, "repairPath").concat(i.faultimgpath)
        },
        on: {
          "click": function click($event) {
            return _vm.handlePreview(i.faultimgpath);
          }
        }
      }, [_c('img', {
        staticStyle: {
          "width": "100px",
          "height": "100px"
        },
        attrs: {
          "src": "".concat(_vm.config.baseUrl, "repairPath").concat(i.faultimgpath),
          "alt": ""
        }
      })])]);
    }), 0) : _vm._e()])], 1)], 1);
  }), 1)], 1)])], 1)])]) : _vm._e(), _c('a-col', {
    staticClass: "jzdj",
    attrs: {
      "span": _vm.spanLeft
    }
  }, [JSON.stringify(_vm.repairList) == '[]' || JSON.stringify(_vm.repairList) == 'null' ? _c('div', {
    staticClass: "jzdj-layer"
  }, [_c('a-spin')], 1) : _vm._e(), _c('div', {
    staticClass: "left-body-content"
  }, [_c('a-card', {
    staticStyle: {
      "pointer-events": "none",
      "opacity": "1"
    },
    attrs: {
      "size": "small",
      "title": "报修信息"
    }
  }, [_c('a-descriptions', {
    attrs: {
      "bordered": "",
      "size": "small"
    }
  }, [_c('a-descriptions-item', {
    attrs: {
      "label": "报修时间"
    }
  }, [_vm._v(" " + _vm._s(_vm.repairList.createTime) + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "报修人"
    }
  }, [_vm._v(" " + _vm._s(_vm.repairList.userName) + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "设备名称"
    }
  }, [_vm._v(" " + _vm._s(_vm.repairList.itemName) + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "设备编号"
    }
  }, [_vm._v(" " + _vm._s(_vm.repairList.itemNum) + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "设备位置"
    }
  }, [_vm._v(" " + _vm._s(_vm.repairList.location) + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "使用部门"
    }
  }, [_vm._v(" " + _vm._s(_vm.repairList.organName || '无') + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "故障时间"
    }
  }, [_vm._v(" " + _vm._s(_vm.repairList.reDate) + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "预约维修时间"
    }
  }, [_vm._v(" " + _vm._s(_vm.repairList.makeServiceDate) + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "故障描述",
      "span": 3
    }
  }, [_c('a-tooltip', [_c('template', {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.repairList.description) + " ")]), _vm._v(" " + _vm._s(_vm.repairList.description) + " ")], 2)], 1), _c('a-descriptions-item', {
    staticClass: "imgClickMenu",
    attrs: {
      "label": "相关图片",
      "span": 3
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "pointer-events": "auto"
    }
  }, _vm._l(_vm.repairList.faultImgList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "image-wapper",
      on: {
        "click": function click($event) {
          return _vm.imageClick(item);
        }
      }
    }, [_c('a', [_c('img', {
      staticStyle: {
        "width": "40px",
        "height": "40px"
      },
      attrs: {
        "src": "".concat(_vm.config.baseUrl, "repairPath").concat(item.faultImgPath),
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(item.faultImgName) + " ")])]);
  }), 0)])], 1)], 1), _c('a-card', {
    staticStyle: {
      "pointer-events": "none",
      "opacity": "1"
    },
    attrs: {
      "size": "small",
      "title": "维修信息"
    }
  }, [JSON.stringify(_vm.completeList) == 'null' || JSON.stringify(_vm.completeList) == '[]' ? _c('a-empty', {
    attrs: {
      "image": _vm.simpleImage
    }
  }) : _c('a-descriptions', {
    attrs: {
      "bordered": "",
      "size": "small"
    }
  }, [_c('a-descriptions-item', {
    attrs: {
      "label": "维修人"
    }
  }, [_vm._v(" " + _vm._s(_vm.completeList.userName) + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "维修状态"
    }
  }, [_vm._v(" " + _vm._s(_vm.completeList.type == 0 ? '维修完成' : '维修中') + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "维修时间"
    }
  }, [_vm._v(" " + _vm._s(_vm.completeList.repairDate) + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "故障原因",
      "span": 3
    }
  }, [_vm._v(" " + _vm._s(_vm.completeList.remark || '无') + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "消耗物品",
      "span": 3
    }
  }, [_c('div', [_c('strong', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "font-size": "16px"
    }
  }, [_vm._v(" 更换零部件清单 ")]), _c('div', [_c('table', {
    staticClass: "single-table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "16%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 名称 ")]), _c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 型号 ")]), _c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "8%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 单位 ")]), _c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "8%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 数量 ")]), _c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 单价 ")]), _c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 总价 ")]), _c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 厂家 ")]), _c('td', {
    staticClass: "txt-center",
    staticStyle: {
      "width": "28%"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(" 损坏原因 ")])]), _vm._l(_vm.completeList.supplies, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      model: {
        value: _vm.completeList.supplies[index].partName,
        callback: function callback($$v) {
          _vm.$set(_vm.completeList.supplies[index], "partName", $$v);
        },
        expression: "\n                                                            completeList.supplies[index]\n                                                                .partName\n                                                        "
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      model: {
        value: _vm.completeList.supplies[index].partModel,
        callback: function callback($$v) {
          _vm.$set(_vm.completeList.supplies[index], "partModel", $$v);
        },
        expression: "\n                                                            completeList.supplies[index]\n                                                                .partModel\n                                                        "
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      model: {
        value: _vm.completeList.supplies[index].partUnit,
        callback: function callback($$v) {
          _vm.$set(_vm.completeList.supplies[index], "partUnit", $$v);
        },
        expression: "\n                                                            completeList.supplies[index]\n                                                                .partUnit\n                                                        "
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      model: {
        value: _vm.completeList.supplies[index].partNumber,
        callback: function callback($$v) {
          _vm.$set(_vm.completeList.supplies[index], "partNumber", $$v);
        },
        expression: "\n                                                            completeList.supplies[index]\n                                                                .partNumber\n                                                        "
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      model: {
        value: _vm.completeList.supplies[index].partPrice,
        callback: function callback($$v) {
          _vm.$set(_vm.completeList.supplies[index], "partPrice", $$v);
        },
        expression: "\n                                                            completeList.supplies[index]\n                                                                .partPrice\n                                                        "
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      model: {
        value: _vm.completeList.supplies[index].totalPrice,
        callback: function callback($$v) {
          _vm.$set(_vm.completeList.supplies[index], "totalPrice", $$v);
        },
        expression: "\n                                                            completeList.supplies[index]\n                                                                .totalPrice\n                                                        "
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 0
      },
      model: {
        value: _vm.completeList.supplies[index].partFactory,
        callback: function callback($$v) {
          _vm.$set(_vm.completeList.supplies[index], "partFactory", $$v);
        },
        expression: "\n                                                            completeList.supplies[index]\n                                                                .partFactory\n                                                        "
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "2"
      }
    }, [_c('a-textarea', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 1,
        "auto-size": {
          maxRows: 2
        }
      },
      model: {
        value: _vm.completeList.supplies[index].damageReason,
        callback: function callback($$v) {
          _vm.$set(_vm.completeList.supplies[index], "damageReason", $$v);
        },
        expression: "\n                                                            completeList.supplies[index]\n                                                                .damageReason\n                                                        "
      }
    })], 1)]);
  })], 2)])])])]), _c('a-descriptions-item', {
    attrs: {
      "label": "相关图片",
      "span": 3
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    }
  }, _vm._l(_vm.completeList.faultImgList, function (item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "padding": "10px",
        "display": "flex",
        "align-items": "center",
        "justify-content": "space-between",
        "border": "1px solid #e0e0e0",
        "border-radius": "10px",
        "margin-bottom": "10px"
      },
      on: {
        "click": function click($event) {
          return _vm.imageClick(item);
        }
      }
    }, [_c('div', [_c('img', {
      staticStyle: {
        "width": "40px",
        "height": "40px"
      },
      attrs: {
        "src": "".concat(_vm.config.baseUrl, "repairPath").concat(item.faultImgPath),
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(item.faultImgName) + " ")])]);
  }), 0)])], 1)], 1), _c('a-card', {
    staticStyle: {
      "pointer-events": "none",
      "opacity": "1"
    },
    attrs: {
      "size": "small",
      "title": "评价"
    }
  }, [JSON.stringify(_vm.evaluateList) == 'null' || JSON.stringify(_vm.evaluateList) == '[]' ? _c('a-empty', {
    attrs: {
      "image": _vm.simpleImage
    }
  }) : _c('a-descriptions', {
    attrs: {
      "bordered": "",
      "size": "small"
    }
  }, [_c('a-descriptions-item', {
    attrs: {
      "label": "评价人"
    }
  }, [_vm._v(" " + _vm._s(_vm.evaluateList.userName) + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "评价时间"
    }
  }, [_vm._v(" " + _vm._s(_vm.evaluateList.repairDate) + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "是否修好"
    }
  }, [_vm._v(" " + _vm._s(_vm.evaluateList.evaluate.isRepair == 0 ? '是' : '否') + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "整体评价"
    }
  }, [_c('a-rate', {
    attrs: {
      "default-value": _vm.evaluateList.evaluate.evaluate,
      "disabled": ""
    }
  })], 1), _c('a-descriptions-item', {
    attrs: {
      "label": "意见建议",
      "span": 3
    }
  }, [_vm._v(" " + _vm._s(_vm.evaluateList.remark) + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "相关图片",
      "span": 3
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    }
  }, _vm._l(_vm.evaluateList.faultImgList, function (item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "padding": "10px",
        "display": "flex",
        "align-items": "center",
        "justify-content": "space-between",
        "border": "1px solid #e0e0e0",
        "border-radius": "10px",
        "margin-bottom": "10px"
      },
      on: {
        "click": function click($event) {
          return _vm.imageClick(item);
        }
      }
    }, [_c('div', [_c('img', {
      staticStyle: {
        "width": "40px",
        "height": "40px"
      },
      attrs: {
        "src": "".concat(_vm.config.baseUrl, "repairPath").concat(item.faultImgPath),
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(item.faultImgName) + " ")])]);
  }), 0)])], 1)], 1)], 1)])], 1), _c('a-modal', {
    attrs: {
      "title": "报修接单",
      "visible": _vm.orderShow,
      "centered": true,
      "maskClosable": false,
      "width": "25%"
    },
    on: {
      "ok": _vm.orderSubmit,
      "cancel": _vm.orderCancel
    }
  }, [_c('a-form-model', {
    ref: "orderForm",
    attrs: {
      "model": _vm.orderForm,
      "rules": _vm.orderFormRules
    }
  }, [_c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "是否接单",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      },
      "prop": "status"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.orderForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.orderForm, "status", $$v);
      },
      expression: "orderForm.status"
    }
  }, [_c('a-row', [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("是")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1)], 1), _vm.orderForm.status == 0 ? _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "维修人",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 10
      },
      "prop": "orderPerson"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }, {
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.orderForm.orderPerson,
      callback: function callback($$v) {
        _vm.$set(_vm.orderForm, "orderPerson", $$v);
      },
      expression: "orderForm.orderPerson"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.orderForm.status == 0 || _vm.orderForm.status == 1 ? _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "内容描述",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      },
      "prop": "orderRemark"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请填写200字以内描述内容！",
      "auto-size": {
        minRows: 3
      },
      "maxLength": 200
    },
    model: {
      value: _vm.orderForm.orderRemark,
      callback: function callback($$v) {
        _vm.$set(_vm.orderForm, "orderRemark", $$v);
      },
      expression: "orderForm.orderRemark"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.orderForm.status == 0 || _vm.orderForm.status == 1 ? _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "附件",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 10
      },
      "prop": "fileList"
    }
  }, [_c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": true,
      "accept": ".jpg,.jpge,.png",
      "default-file-list": _vm.orderForm.fileList,
      "customRequest": _vm.orderActionUpload,
      "before-upload": _vm.beforeUpload,
      "remove": _vm.orderDelFile,
      "file-list": _vm.orderForm.fileList
    },
    model: {
      value: _vm.orderForm.fileList,
      callback: function callback($$v) {
        _vm.$set(_vm.orderForm, "fileList", $$v);
      },
      expression: "orderForm.fileList"
    }
  }, [_c('a-button', {
    attrs: {
      "icon": "inbox"
    }
  }, [_vm._v("点击上传附件")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _c('a-modal', {
    attrs: {
      "title": "反馈报修单",
      "visible": _vm.feedbackStatus,
      "centered": true,
      "maskClosable": false,
      "width": _vm.feedBackWidth
    },
    on: {
      "ok": _vm.feedbackSubmit,
      "cancel": _vm.feedbackCancel
    }
  }, [_c('a-form-model', {
    ref: "feedbackForm",
    attrs: {
      "rules": _vm.feedbackFormRules,
      "model": _vm.feedbackForm
    }
  }, [_c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "维修状态",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      },
      "prop": "status"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.feedbackForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.feedbackForm, "status", $$v);
      },
      expression: "feedbackForm.status"
    }
  }, [_c('a-row', [_c('a-radio', {
    attrs: {
      "value": 0
    },
    on: {
      "click": _vm.feedclick
    }
  }, [_vm._v("维修完成")])], 1)], 1)], 1)], 1)], 1), _vm.feedbackForm.status == 0 ? _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "维修时间",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 5
      },
      "prop": "repairDate"
    }
  }, [_c('a-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.feedbackForm.repairDate,
      callback: function callback($$v) {
        _vm.$set(_vm.feedbackForm, "repairDate", $$v);
      },
      expression: "feedbackForm.repairDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.feedbackForm.status == 0 ? _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "更换零件清单",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      },
      "prop": "partsList"
    }
  }, [_c('table', {
    staticClass: "single-table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "txt-center",
    style: _vm.feedbackForm.partsList.matterList.length == 0 ? {
      width: '10%'
    } : {
      width: '10%',
      borderBottom: '0px'
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 名称 ")]), _c('td', {
    staticClass: "txt-center",
    style: _vm.feedbackForm.partsList.matterList.length == 0 ? {
      width: '10%'
    } : {
      width: '10%',
      borderBottom: '0px'
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 型号 ")]), _c('td', {
    staticClass: "txt-center",
    style: _vm.feedbackForm.partsList.matterList.length == 0 ? {
      width: '10%'
    } : {
      width: '10%',
      borderBottom: '0px'
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 单位 ")]), _c('td', {
    staticClass: "txt-center",
    style: _vm.feedbackForm.partsList.matterList.length == 0 ? {
      width: '10%'
    } : {
      width: '10%',
      borderBottom: '0px'
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 数量 ")]), _c('td', {
    staticClass: "txt-center",
    style: _vm.feedbackForm.partsList.matterList.length == 0 ? {
      width: '10%'
    } : {
      width: '10%',
      borderBottom: '0px'
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 单价 ")]), _c('td', {
    staticClass: "txt-center",
    style: _vm.feedbackForm.partsList.matterList.length == 0 ? {
      width: '10%'
    } : {
      width: '10%',
      borderBottom: '0px'
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 总价 ")]), _c('td', {
    staticClass: "txt-center",
    style: _vm.feedbackForm.partsList.matterList.length == 0 ? {
      width: '10%'
    } : {
      width: '10%',
      borderBottom: '0px'
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" 厂家 ")]), _c('td', {
    staticClass: "txt-center",
    style: _vm.feedbackForm.partsList.matterList.length == 0 ? {
      width: '10%'
    } : {
      width: '10%',
      borderBottom: '0px'
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(" 损坏原因 ")]), _c('a-icon', {
    staticClass: "oper-icon",
    attrs: {
      "type": "plus-circle",
      "title": "添加"
    },
    on: {
      "click": _vm.addMatter
    }
  })], 1), _vm._l(_vm.feedbackForm.partsList.matterList, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      model: {
        value: _vm.feedbackForm.partsList.matterList[index].partName,
        callback: function callback($$v) {
          _vm.$set(_vm.feedbackForm.partsList.matterList[index], "partName", $$v);
        },
        expression: "\n                                                feedbackForm.partsList.matterList[index]\n                                                    .partName\n                                            "
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      model: {
        value: _vm.feedbackForm.partsList.matterList[index].partModel,
        callback: function callback($$v) {
          _vm.$set(_vm.feedbackForm.partsList.matterList[index], "partModel", $$v);
        },
        expression: "\n                                                feedbackForm.partsList.matterList[index]\n                                                    .partModel\n                                            "
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      model: {
        value: _vm.feedbackForm.partsList.matterList[index].partUnit,
        callback: function callback($$v) {
          _vm.$set(_vm.feedbackForm.partsList.matterList[index], "partUnit", $$v);
        },
        expression: "\n                                                feedbackForm.partsList.matterList[index]\n                                                    .partUnit\n                                            "
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 0
      },
      on: {
        "change": function change($event) {
          return _vm.partNumberChange(index);
        }
      },
      model: {
        value: _vm.feedbackForm.partsList.matterList[index].partNumber,
        callback: function callback($$v) {
          _vm.$set(_vm.feedbackForm.partsList.matterList[index], "partNumber", $$v);
        },
        expression: "\n                                                feedbackForm.partsList.matterList[index]\n                                                    .partNumber\n                                            "
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      on: {
        "change": function change($event) {
          return _vm.partPriceChange(index);
        }
      },
      model: {
        value: _vm.feedbackForm.partsList.matterList[index].partPrice,
        callback: function callback($$v) {
          _vm.$set(_vm.feedbackForm.partsList.matterList[index], "partPrice", $$v);
        },
        expression: "\n                                                feedbackForm.partsList.matterList[index]\n                                                    .partPrice\n                                            "
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2,
        "disabled": ""
      },
      model: {
        value: _vm.feedbackForm.partsList.matterList[index].totalPrice,
        callback: function callback($$v) {
          _vm.$set(_vm.feedbackForm.partsList.matterList[index], "totalPrice", $$v);
        },
        expression: "\n                                                feedbackForm.partsList.matterList[index]\n                                                    .totalPrice\n                                            "
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "1"
      }
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 0
      },
      model: {
        value: _vm.feedbackForm.partsList.matterList[index].partFactory,
        callback: function callback($$v) {
          _vm.$set(_vm.feedbackForm.partsList.matterList[index], "partFactory", $$v);
        },
        expression: "\n                                                feedbackForm.partsList.matterList[index]\n                                                    .partFactory\n                                            "
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      attrs: {
        "colspan": "2"
      }
    }, [_c('a-textarea', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 1,
        "auto-size": {
          maxRows: 2
        },
        "maxLength": 300
      },
      model: {
        value: _vm.feedbackForm.partsList.matterList[index].damageReason,
        callback: function callback($$v) {
          _vm.$set(_vm.feedbackForm.partsList.matterList[index], "damageReason", $$v);
        },
        expression: "\n                                                feedbackForm.partsList.matterList[index]\n                                                    .damageReason\n                                            "
      }
    })], 1), _c('td', {
      staticStyle: {
        "border": "0"
      }
    }, [_c('a-popconfirm', {
      attrs: {
        "title": "确认删除该条记录？",
        "ok-text": "确认",
        "placement": "topLeft",
        "cancel-text": "取消"
      },
      on: {
        "confirm": function confirm($event) {
          return _vm.delMatter(item);
        }
      }
    }, [_c('a-icon', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "slot": "icon",
        "type": "question-circle-o"
      },
      slot: "icon"
    }), _vm.feedbackForm.partsList.matterList.length > 0 ? _c('a-icon', {
      staticClass: "oper-icon",
      attrs: {
        "type": "minus-circle",
        "title": "删除"
      }
    }) : _vm._e()], 1)], 1)]);
  })], 2)])])], 1)], 1) : _vm._e(), _vm.feedbackForm.status == 0 || _vm.feedbackForm.status == 1 ? _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "反馈内容",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      },
      "prop": "feedbackRemark"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入300字以内反馈内容！",
      "auto-size": {
        minRows: 3
      },
      "maxLength": 300
    },
    model: {
      value: _vm.feedbackForm.feedbackRemark,
      callback: function callback($$v) {
        _vm.$set(_vm.feedbackForm, "feedbackRemark", $$v);
      },
      expression: "feedbackForm.feedbackRemark"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.feedbackForm.status == 0 || _vm.feedbackForm.status == 1 ? _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "附件",
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 10
      },
      "prop": "fileList"
    }
  }, [_c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": true,
      "accept": ".jpg,.jpge,.png",
      "default-file-list": _vm.feedbackForm.fileList,
      "customRequest": _vm.feedbackActionUpload,
      "before-upload": _vm.beforeUpload,
      "remove": _vm.feedbackDelFile,
      "file-list": _vm.feedbackForm.fileList
    },
    model: {
      value: _vm.feedbackForm.fileList,
      callback: function callback($$v) {
        _vm.$set(_vm.feedbackForm, "fileList", $$v);
      },
      expression: "feedbackForm.fileList"
    }
  }, [_c('a-button', {
    attrs: {
      "icon": "inbox"
    }
  }, [_vm._v("点击上传附件")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _c('a-modal', {
    attrs: {
      "title": "派单人员选择",
      "visible": _vm.sendOrdersShow,
      "centered": true,
      "maskClosable": false,
      "width": "25%"
    },
    on: {
      "ok": _vm.sendOrdersSubmit,
      "cancel": _vm.sendOrdersCancel
    }
  }, [_c('a-form-model', {
    ref: "sendOrderForm",
    attrs: {
      "model": _vm.sendOrderForm,
      "rules": _vm.sendOrderFormRules
    }
  }, [_c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "维修类别",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c('a-radio-group', {
    on: {
      "change": _vm.handleChangeSendOrder
    },
    model: {
      value: _vm.sendOrderForm.type,
      callback: function callback($$v) {
        _vm.$set(_vm.sendOrderForm, "type", $$v);
      },
      expression: "sendOrderForm.type"
    }
  }, [_c('a-row', [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("校内人员维修")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("校外人员维修")])], 1)], 1)], 1)], 1)], 1), _vm.sendOrderForm.type === 0 ? _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "校内人员维修",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 10
      },
      "prop": "servicePerson"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择校内人员维修"
    },
    model: {
      value: _vm.sendOrderForm.servicePerson,
      callback: function callback($$v) {
        _vm.$set(_vm.sendOrderForm, "servicePerson", $$v);
      },
      expression: "sendOrderForm.servicePerson"
    }
  }, _vm._l(_vm.repairPersonList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.userId
      }
    }, [_vm._v(" " + _vm._s(item.userName) + " ")]);
  }), 1)], 1)], 1)], 1) : _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "校外人员维修",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 10
      },
      "prop": "servicePerson"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择校外人员维修"
    },
    model: {
      value: _vm.sendOrderForm.servicePerson,
      callback: function callback($$v) {
        _vm.$set(_vm.sendOrderForm, "servicePerson", $$v);
      },
      expression: "sendOrderForm.servicePerson"
    }
  }, _vm._l(_vm.outerPersonList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.userId
      }
    }, [_vm._v(" " + _vm._s(item.perName) + " ")]);
  }), 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "备注信息",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      },
      "prop": "remarksContent"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入200字以内备注内容！",
      "auto-size": {
        minRows: 3
      },
      "maxLength": 200
    },
    model: {
      value: _vm.sendOrderForm.remarksContent,
      callback: function callback($$v) {
        _vm.$set(_vm.sendOrderForm, "remarksContent", $$v);
      },
      expression: "sendOrderForm.remarksContent"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "附件",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      },
      "prop": "fileList"
    }
  }, [_c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": true,
      "accept": ".jpg,.jpge,.png",
      "default-file-list": _vm.sendOrderForm.fileList,
      "customRequest": _vm.sendOrderActionUpload,
      "before-upload": _vm.beforeUpload,
      "remove": _vm.sendOrderDelFile,
      "file-list": _vm.sendOrderForm.fileList
    },
    model: {
      value: _vm.sendOrderForm.fileList,
      callback: function callback($$v) {
        _vm.$set(_vm.sendOrderForm, "fileList", $$v);
      },
      expression: "sendOrderForm.fileList"
    }
  }, [_c('a-button', {
    attrs: {
      "icon": "inbox"
    }
  }, [_vm._v("点击上传附件")])], 1)], 1)], 1)], 1)], 1)], 1), _c('a-modal', {
    attrs: {
      "title": "受理报修单",
      "visible": _vm.acceptShow,
      "centered": true,
      "maskClosable": false,
      "width": "30%"
    },
    on: {
      "ok": _vm.acceptSubmit,
      "cancel": _vm.acceptCancel
    }
  }, [_vm.mode === 'accept' ? _c('a-form-model', {
    ref: "acceptanceForm",
    attrs: {
      "model": _vm.acceptanceForm,
      "rules": _vm.acceptanceFormRules
    }
  }, [_c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "内容确认",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      },
      "prop": "status"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.acceptanceForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.acceptanceForm, "status", $$v);
      },
      expression: "acceptanceForm.status"
    }
  }, [_c('a-row', [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("确认受理")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("无法受理")])], 1)], 1)], 1)], 1)], 1), _c('a-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.acceptanceForm.status == 0,
      expression: "acceptanceForm.status == 0"
    }]
  }, [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "维修类别",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      },
      "prop": "category"
    }
  }, [_c('a-radio-group', {
    on: {
      "change": _vm.handleChangeCategory
    },
    model: {
      value: _vm.acceptanceForm.category,
      callback: function callback($$v) {
        _vm.$set(_vm.acceptanceForm, "category", $$v);
      },
      expression: "acceptanceForm.category"
    }
  }, [_c('a-row', [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("校内人员维修")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("校外人员维修")])], 1)], 1)], 1)], 1)], 1), _vm.acceptanceForm.category == 0 && _vm.acceptanceForm.status == 0 ? _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "校内人员维修",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 10
      },
      "prop": "maintainuser"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择校内人员维修"
    },
    model: {
      value: _vm.acceptanceForm.maintainuser,
      callback: function callback($$v) {
        _vm.$set(_vm.acceptanceForm, "maintainuser", $$v);
      },
      expression: "acceptanceForm.maintainuser"
    }
  }, _vm._l(_vm.repairPersonList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.userId
      }
    }, [_vm._v(" " + _vm._s(item.userName) + " ")]);
  }), 1)], 1)], 1)], 1) : _vm.acceptanceForm.category == 1 && _vm.acceptanceForm.status == 0 ? _c('a-row', [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "校外人员维修",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 10
      },
      "prop": "maintainuser"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择校外人员维修"
    },
    model: {
      value: _vm.acceptanceForm.maintainuser,
      callback: function callback($$v) {
        _vm.$set(_vm.acceptanceForm, "maintainuser", $$v);
      },
      expression: "acceptanceForm.maintainuser"
    }
  }, _vm._l(_vm.outerPersonList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.userId
      }
    }, [_vm._v(" " + _vm._s(item.perName) + " ")]);
  }), 1)], 1)], 1)], 1) : _vm._e(), _c('a-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.acceptanceForm.status == 0 || _vm.acceptanceForm.status == 1,
      expression: "acceptanceForm.status == 0 || acceptanceForm.status == 1"
    }]
  }, [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "备注信息",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      },
      "prop": "remarksContent"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入200字以内备注内容！",
      "auto-size": {
        minRows: 3
      },
      "maxLength": 200
    },
    model: {
      value: _vm.acceptanceForm.remarksContent,
      callback: function callback($$v) {
        _vm.$set(_vm.acceptanceForm, "remarksContent", $$v);
      },
      expression: "acceptanceForm.remarksContent"
    }
  })], 1)], 1)], 1), _c('a-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.acceptanceForm.status == 0 || _vm.acceptanceForm.status == 1,
      expression: "acceptanceForm.status == 0 || acceptanceForm.status == 1"
    }]
  }, [_c('a-col', [_c('a-form-model-item', {
    attrs: {
      "label": "附件",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      },
      "prop": "fileList"
    }
  }, [_c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": true,
      "accept": ".jpg,.jpge,.png",
      "default-file-list": _vm.acceptanceForm.acceptanceFormList,
      "customRequest": _vm.actionUpload,
      "before-upload": _vm.beforeUpload,
      "remove": _vm.delFile,
      "file-list": _vm.acceptanceForm.acceptanceFormList
    },
    model: {
      value: _vm.acceptanceForm.acceptanceFormList,
      callback: function callback($$v) {
        _vm.$set(_vm.acceptanceForm, "acceptanceFormList", $$v);
      },
      expression: "acceptanceForm.acceptanceFormList"
    }
  }, [_c('a-button', {
    attrs: {
      "icon": "inbox"
    }
  }, [_vm._v("点击上传附件")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _c('a-modal', {
    attrs: {
      "title": "维修评价",
      "visible": _vm.evaluation,
      "centered": true,
      "maskClosable": false,
      "width": "25%"
    },
    on: {
      "ok": _vm.evaluationSubmit,
      "cancel": _vm.evaluationCancel
    }
  }, [_c('a-form-model', {
    ref: "evaluationForm",
    attrs: {
      "model": _vm.evaluationForm,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      },
      "rules": _vm.evaluationFormRules
    }
  }, [_c('a-form-model-item', {
    staticClass: "speedValueClass",
    attrs: {
      "label": "是否修好",
      "prop": "isRepair"
    }
  }, [_c('a-radio-group', {
    attrs: {
      "name": "radioGroup",
      "default-value": 0
    },
    model: {
      value: _vm.evaluationForm.isRepair,
      callback: function callback($$v) {
        _vm.$set(_vm.evaluationForm, "isRepair", $$v);
      },
      expression: "evaluationForm.isRepair"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("是")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("否")])], 1)], 1), _c('a-form-model-item', {
    staticClass: "speedValueClass",
    attrs: {
      "label": "整体评价",
      "prop": "evaluate"
    }
  }, [_c('a-rate', {
    model: {
      value: _vm.evaluationForm.evaluate,
      callback: function callback($$v) {
        _vm.$set(_vm.evaluationForm, "evaluate", $$v);
      },
      expression: "evaluationForm.evaluate"
    }
  })], 1), _c('a-form-model-item', {
    staticClass: "speedValueClass",
    attrs: {
      "label": "意见建议",
      "prop": "timeRange"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入300字以内您宝贵的意见和建议！",
      "auto-size": {
        minRows: 3
      },
      "maxLength": 300
    },
    model: {
      value: _vm.evaluationForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.evaluationForm, "remark", $$v);
      },
      expression: "evaluationForm.remark"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "附件",
      "prop": "fileList"
    }
  }, [_c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": true,
      "accept": ".jpg,.jpge,.png",
      "default-file-list": _vm.evaluationForm.fileList,
      "customRequest": _vm.evaluationFormActionUpload,
      "before-upload": _vm.beforeUpload,
      "remove": _vm.evaluationFormDelFile,
      "file-list": _vm.evaluationForm.fileList
    },
    model: {
      value: _vm.evaluationForm.fileList,
      callback: function callback($$v) {
        _vm.$set(_vm.evaluationForm, "fileList", $$v);
      },
      expression: "evaluationForm.fileList"
    }
  }, [_c('a-button', {
    attrs: {
      "icon": "inbox"
    }
  }, [_vm._v("点击上传附件")])], 1)], 1)], 1)], 1), _c('a-modal', {
    attrs: {
      "visible": _vm.previewShow,
      "footer": null,
      "centered": true,
      "width": "80rem"
    },
    on: {
      "cancel": _vm.handleCancel
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "calc(70vh)"
    },
    attrs: {
      "src": _vm.imageUrl,
      "alt": ""
    }
  })])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };